{
  "version": 1,
  "asset_id": "cd90bb5a-81f8-4bc9-8bfd-fa4b68cda9b5",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/cd90bb5a-81f8-4bc9-8bfd-fa4b68cda9b5/avcilar-hizli-elektrikci-7-24-dukkan-8.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/cd90bb5a-81f8-4bc9-8bfd-fa4b68cda9b5/avcilar-hizli-elektrikci-7-24-dukkan-8.jpg",
  "original_filename": "avcilar-hizli-elektrikci-7-24-dukkan-8.jpg",
  "size": 467906,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T13:23:51Z"
}
